'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _componentsDatagrid = require('../../components/Datagrid');

var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);

var _helpersRenderers = require('../../helpers/Renderers');

var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var _constants2 = _interopRequireDefault(_constants);

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactisDatagrid = require('reactis-datagrid');

var _reactBootstrap = require('react-bootstrap');

var _reactisModal = require('reactis-modal');

var _EventEmitter = require('../../EventEmitter');

var _EventEmitter2 = _interopRequireDefault(_EventEmitter);

var _componentsFormDateRange = require('../../components/Form/DateRange');

var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _reactRedux = require('react-redux');

var _componentsFormActiveSelect = require('../../components/Form/ActiveSelect');

var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);

var _redux = require('redux');

var _componentsFormClientLookup = require('../../components/Form/ClientLookup');

var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);

var _reduxModulesInvoice = require('../../redux/modules/invoice');

var invoiceActions = _interopRequireWildcard(_reduxModulesInvoice);

var _RowItems = require('./RowItems');

var _RowItems2 = _interopRequireDefault(_RowItems);

var _components = {
	_$List: {
		displayName: 'List'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var List = (function (_Component) {
	_inherits(List, _Component);

	function List(props, context) {
		var _this = this;

		_classCallCheck(this, _List);

		_Component.call(this, props);

		var rendererLink = function rendererLink(val, row) {
			return _react2['default'].createElement(
				'a',
				{ href: '/invoice/' + row.id, onClick: function (e) {
						return _this.handleOpen(row, e);
					} },
				val
			);
		};

		this.columnModel = [{
			name: 'number',
			title: 'Číslo',
			field: 'number',
			align: 'center',
			width: 70,
			renderer: rendererLink
		}, {
			name: 'date1',
			title: 'Datum',
			field: 'date1',
			width: 115,
			align: 'right',
			viewport: 'tablet',
			renderer: _helpersRenderers2['default'].Date
		}, {
			name: 'client',
			title: 'Klient',
			field: 'client',
			viewport: 'tablet',
			renderer: rendererLink
		}, {
			name: 'price',
			title: 'Cena',
			field: 'price',
			align: 'right',
			width: 100,
			suffix: ' Kč',
			renderer: _helpersRenderers2['default'].Number,
			viewport: 'tablet'
		}, {
			name: 'status',
			title: 'Zapl.',
			field: 'status',
			width: 50,
			align: 'center',
			viewport: 'tablet',
			renderer: _helpersRenderers2['default'].coloredCheck
		}, {
			name: 'edit',
			title: 'Akce',
			field: 'id',
			width: 80,
			sortable: false,
			renderer: function renderer(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/invoice/' + val, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
					' Upravit'
				);
			}
		}];

		var filterSchema = {
			id: { 'class': _reactisInputs.FilterInput },
			number: { 'class': _reactisInputs.FilterInput },
			client: { 'class': _componentsFormClientLookup2['default'] },
			date1: { 'class': _componentsFormDateRange2['default'] },
			price: {
				'class': _reactisInputs.Select,
				options: [{ id: 1, title: '< 3 000 Kč' }, {
					id: 2,
					title: '> 3 000 Kč'
				}]
			},
			status: {
				'class': _reactisInputs.Select,
				options: _dbinfo2['default'].YesNo.asArray()
			},
			fulltext: { 'class': _reactisInputs.SearchInput },
			edit: {
				'class': _reactisDatagrid.FilterResetButton,
				visible: function visible() {
					return _this.filter.isChanged();
				},
				onClick: function onClick() {
					return _this.filter.reset();
				}
			}
		};
		this.filter = new _reactisForms.FormManager(filterSchema);
		this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'id', 'direction': 'desc' };
		this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : {};
	}

	List.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this.changeListener = function () {
			_this2.refs.datagrid.getWrappedInstance().refresh();
		};
		_EventEmitter2['default'].on('invoice.change', this.changeListener);
	};

	List.prototype.componentWillUnmount = function componentWillUnmount() {
		_EventEmitter2['default'].removeListener('invoice.change', this.changeListener);
	};

	List.prototype.handleOpen = function handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('invoice', '#' + row.number, row);
	};

	List.prototype.handleNewClick = function handleNewClick(e) {
		e.preventDefault();
		this.props.onNewTab();
	};

	List.prototype.setStatusPayed = function setStatusPayed(status, action) {
		this.props.invoiceActions.setStatus(action, status).then(function () {
			_EventEmitter2['default'].emit('invoice.change');
		});
	};

	List.prototype.render = function render() {
		var _this3 = this;

		var buttons = _react2['default'].createElement(
			_reactBootstrap.Button,
			{ href: '/trigger/0', onClick: function (e) {
					return _this3.handleNewClick(e);
				} },
			_react2['default'].createElement('i', { className: 'fa fa-plus' }),
			' Nová faktura'
		);

		var actions = [{ title: 'Označit jako zaplacené', onClick: function onClick(action) {
				return _this3.setStatusPayed(2, action);
			} }, { title: 'Označit jako nezaplacené', onClick: function onClick(action) {
				return _this3.setStatusPayed(1, action);
			} }];

		return _react2['default'].createElement(_componentsDatagrid2['default'], {
			ref: 'datagrid',
			id: 'invoice',
			api: 'invoice.getList',
			multiActions: actions,
			buttons: buttons,
			expandableComponent: _RowItems2['default'],
			filters: ['fulltext'],
			filter: this.filter,
			saveState: true,
			getRowClassName: null,
			columnModel: this.columnModel,
			defaultFilter: this.defaultFilter,
			defaultSort: this.defaultSort
		});
	};

	var _List = List;
	List = _wrapComponent('_$List')(List) || List;
	List = _reactRedux.connect(function (state, props) {
		return {
			defaultState: state.datagridDefaultState[props.module]
		};
	}, function (dispatch) {
		return { invoiceActions: _redux.bindActionCreators(invoiceActions, dispatch) };
	})(List) || List;
	return List;
})(_componentsComponent2['default']);

exports['default'] = List;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Invoice/List.js
 ** module id = 986
 ** module chunks = 2
 **/